import React, { useState, useEffect } from "react";
import api from "./api";

export default function Precificacao({ token }) {
  const [config, setConfig] = useState({
    preco_prata_g: 5.50,
    custo_mao_obra: 15.00,
    custo_banho: 3.00,
    custo_embalagem: 2.00,
    markup_percentual: 300,
  });

  const [calc, setCalc] = useState({
    peso_prata_g: 3.0,
    custo_pedras: 2.00,
    outros_custos: 0,
  });

  const [result, setResult] = useState(null);
  const [savedMsg, setSavedMsg] = useState("");

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    api.get("/api/precificacao/config", { headers }).then((res) => {
      if (res.data && res.data.preco_prata_g) setConfig(res.data);
    }).catch(() => {});
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    calcular();
    // eslint-disable-next-line
  }, [calc, config]);

  const calcular = async () => {
    try {
      const body = {
        peso_prata_g: parseFloat(calc.peso_prata_g) || 0,
        preco_prata_g: parseFloat(config.preco_prata_g) || 0,
        custo_pedras: parseFloat(calc.custo_pedras) || 0,
        custo_mao_obra: parseFloat(config.custo_mao_obra) || 0,
        custo_banho: parseFloat(config.custo_banho) || 0,
        custo_embalagem: parseFloat(config.custo_embalagem) || 0,
        outros_custos: parseFloat(calc.outros_custos) || 0,
        markup_percentual: parseFloat(config.markup_percentual) || 300,
      };
      const res = await api.post("/api/precificacao/calcular", body, { headers });
      setResult(res.data);
    } catch {
      // silencioso
    }
  };

  const salvarConfig = async () => {
    try {
      await api.put("/api/precificacao/config", {
        preco_prata_g: parseFloat(config.preco_prata_g),
        custo_mao_obra: parseFloat(config.custo_mao_obra),
        custo_banho: parseFloat(config.custo_banho),
        custo_embalagem: parseFloat(config.custo_embalagem),
        markup_percentual: parseFloat(config.markup_percentual),
      }, { headers });
      setSavedMsg("Configuracoes salvas!");
      setTimeout(() => setSavedMsg(""), 2000);
    } catch {
      setSavedMsg("Erro ao salvar");
    }
  };

  const setC = (key, val) => setConfig((c) => ({ ...c, [key]: val }));
  const setP = (key, val) => setCalc((c) => ({ ...c, [key]: val }));

  return (
    <div className="precificacao">
      <h2>Calculadora de Precificacao</h2>

      <div className="prec-grid">
        <div className="prec-section">
          <h3>Configuracoes Fixas</h3>
          <p className="prec-hint">Valores padrao que se aplicam a todos os produtos</p>

          <div className="form-row">
            <label>Preco da Prata (R$/grama)</label>
            <input type="number" step="0.01" value={config.preco_prata_g}
              onChange={(e) => setC("preco_prata_g", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Mao de Obra (R$)</label>
            <input type="number" step="0.01" value={config.custo_mao_obra}
              onChange={(e) => setC("custo_mao_obra", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Banho de Rodio (R$)</label>
            <input type="number" step="0.01" value={config.custo_banho}
              onChange={(e) => setC("custo_banho", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Embalagem (R$)</label>
            <input type="number" step="0.01" value={config.custo_embalagem}
              onChange={(e) => setC("custo_embalagem", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Markup (%)</label>
            <input type="number" step="1" value={config.markup_percentual}
              onChange={(e) => setC("markup_percentual", e.target.value)} />
            <span className="prec-hint">{(parseFloat(config.markup_percentual) / 100).toFixed(1)}x o custo</span>
          </div>
          <button className="btn btn-primary" onClick={salvarConfig}>Salvar Configuracoes</button>
          {savedMsg && <span className="prec-saved">{savedMsg}</span>}
        </div>

        <div className="prec-section">
          <h3>Calcular Produto</h3>
          <p className="prec-hint">Insira os dados especificos do produto</p>

          <div className="form-row">
            <label>Peso da Prata (gramas)</label>
            <input type="number" step="0.1" value={calc.peso_prata_g}
              onChange={(e) => setP("peso_prata_g", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Custo das Pedras (R$)</label>
            <input type="number" step="0.01" value={calc.custo_pedras}
              onChange={(e) => setP("custo_pedras", e.target.value)} />
          </div>
          <div className="form-row">
            <label>Outros Custos (R$)</label>
            <input type="number" step="0.01" value={calc.outros_custos}
              onChange={(e) => setP("outros_custos", e.target.value)} />
          </div>

          {result && (
            <div className="prec-result">
              <div className="prec-result-row">
                <span>Custo da Prata</span>
                <span>R$ {result.custo_prata.toFixed(2)}</span>
              </div>
              <div className="prec-result-row prec-total">
                <span>Custo Total</span>
                <span>R$ {result.custo_total.toFixed(2)}</span>
              </div>
              <div className="prec-result-row prec-price">
                <span>Preco de Venda Sugerido</span>
                <span>R$ {result.preco_venda.toFixed(2)}</span>
              </div>
              <div className="prec-result-row">
                <span>Lucro por unidade</span>
                <span>R$ {result.lucro.toFixed(2)}</span>
              </div>
              <div className="prec-result-row">
                <span>Margem de lucro</span>
                <span>{result.margem.toFixed(1)}%</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
